import { UserOrg } from 'graphql/types/userOrgs';

export const searchOrg = (searchKeyWord: string, organizations: UserOrg[]) => {
    const filteredOrgs = organizations
        .filter((org) =>
            org.name.toLowerCase().includes(searchKeyWord.trim().toLowerCase()),
        )
        .sort((a, b) => a.name.localeCompare(b.name));

    return filteredOrgs;
};
